import { ChatInterface, FilterRequestData, ChatReviewFormDataInterface } from '@/services/QC-V2/chat/interfaces';
import { CommentRate } from '@/services/QC-V2/comment/interfaces';
import { TicketInterface, TicketReviewFormDataInterface } from '@/services/QC-V2/ticket/interfaces';

export enum FeedbackStatus {
  SENT,
  SEEN,
  REPLIED,
  ANSWERED,
  CLOSED,
}

export interface ChatFeedbackCreateInterface {
  chatId: string;
  feedbackFrom: string;
  feedbackTo: string;
  isDraft: boolean;
  status: FeedbackStatus;
}

export interface TicketFeedbackCreateInterface {
  ticketId: number;
  feedbackFrom: string;
  feedbackTo: string;
  isDraft: boolean;
  status: FeedbackStatus;
}

export interface FeedbackCommentInterface {
  id: number;
  author: string;
  text: string;
  timestamp: Date;
  rate: CommentRate;
}

export interface ChatFeedbackInterface {
  id: number;
  feedbackFrom: string;
  feedbackTo: string;
  timestamp: string;
  status: FeedbackStatus;
  chat: ChatInterface,
  comments: FeedbackCommentInterface[];
}

export interface TicketFeedbackInterface {
  id: number;
  feedbackFrom: string;
  feedbackTo: string;
  timestamp: string;
  status: FeedbackStatus;
  ticket: TicketInterface,
  comments: FeedbackCommentInterface[];
}

export interface FeedbackRepositoryInterface {
  createChatFeedback(
    feedback: ChatFeedbackCreateInterface,
    review: ChatReviewFormDataInterface,
  ): Promise<void>;

  createTicketFeedback(
    feedback: TicketFeedbackCreateInterface,
    review: TicketReviewFormDataInterface,
  ): Promise<void>;

  updateChatFeedback(id: number, review: ChatReviewFormDataInterface): Promise<void>;

  updateTicketFeedback(id: number, review: TicketReviewFormDataInterface): Promise<void>;

  getAllChatFeedbacks(filterRequestData?: FilterRequestData): Promise<[ChatFeedbackInterface[], number]>;

  getAllTicketFeedbacks(filterRequestData?: FilterRequestData): Promise<[TicketFeedbackInterface[], number]>;

  getChatFeedback(id: number): Promise<ChatFeedbackInterface>;

  getTicketFeedback(id: number): Promise<TicketFeedbackInterface>;

  changeChatFeedbackStatus(id: number, status: FeedbackStatus): Promise<void>;

  changeTicketFeedbackStatus(id: number, status: FeedbackStatus): Promise<void>;
}
